import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-submit-speech',
  templateUrl: './submit-speech.component.html',
  styleUrls: ['./submit-speech.component.css']
})
export class SubmitSpeechComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
